class Input {
    constructor(element) {
        this.inputField = element.querySelector(".form__input-field");
        this.clearBtn = element.querySelector(".form__input-clear-btn");

        if (!this.clearBtn) return;

        this.inputField.addEventListener('input', this.toggleClearButton.bind(this));

        this.clearBtn.addEventListener('click', this.clearInput.bind(this));
    }

    toggleClearButton() {
        const valueExists = this.inputField.value.trim() !== '';
        this.clearBtn.classList.toggle('d-none', !valueExists);
    }

    clearInput() {
        this.inputField.value = '';
        this.clearBtn.classList.add('d-none');
    }
}

export default Input;
